import { render, staticRenderFns } from "./channelTool.vue?vue&type=template&id=44c54020&"
import script from "./channelTool.vue?vue&type=script&lang=js&"
export * from "./channelTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports